export default "__VITE_ASSET__DJV8btIN__"